const _excluded = ["steps", "activeStepIndex", "activeSteps", "onStepClick", "completedSteps"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import { Typography, VerticalStepper } from 'seagull';
import styles from "./Stepper.module.scss";
import { useFeatureFlags } from "../../../../hooks/useFeatureFlags";
import { useCobConfig } from "../../../clientOb/CobConfigContext";
export function Stepper(_ref) {
  let {
    steps,
    activeStepIndex,
    activeSteps,
    onStepClick,
    completedSteps
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  const [completedStepperStep, setCompletedStepperStep] = useState(Math.max(activeStepIndex - 1, 0));
  const {
    isPreview
  } = useCobConfig();
  const {
    COB_IMPROVEMENTS
  } = useFeatureFlags();
  useEffect(() => {
    if (completedStepperStep < activeStepIndex - 1) {
      setCompletedStepperStep(activeStepIndex - 1);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [activeStepIndex, completedStepperStep]);
  const stepperSteps = steps.map((text, i) => {
    const disabled = COB_IMPROVEMENTS ? i === activeStepIndex : i !== activeStepIndex && i > completedStepperStep && !isPreview;
    return {
      component: /*#__PURE__*/React.createElement(Typography, {
        variant: "paragraph2",
        weight: i === activeStepIndex ? 'bold' : 'light',
        className: cn(styles.stepperStep, !disabled ? styles.clickableStep : '')
      }, text),
      completed: COB_IMPROVEMENTS ? completedSteps.includes(i) : i <= completedStepperStep,
      disabled: disabled,
      active: COB_IMPROVEMENTS ? activeSteps.includes(i) : undefined
    };
  });
  return /*#__PURE__*/React.createElement(VerticalStepper, _extends({
    steps: stepperSteps,
    activeStepIndex: activeStepIndex,
    onStepClick: onStepClick
  }, rest));
}